var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tooltip',{attrs:{"bottom":"","max-width":"900"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({},'v-btn',attrs,false),on),[_vm._v(" 条件を表示 ")])]}}])},[_vm._v(" ・5日以内にセッション数2回以上 "),_c('br'),_vm._v(" ・INTEGRAL-CORE サービスサイト閲覧 "),_c('br'),_vm._v(" ・INTEGRAL-CORE Spring Campaign BLOG PV ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }